// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type MemberDetailsQueryVariables = Types.Exact<{
  membershipId: Types.Scalars["ID"]["input"];
}>;

export type MemberDetailsQuery = {
  __typename?: "GraphqlQuery";
  getOrganizationMembershipDetails: {
    __typename?: "OrganizationMembership";
    id: string;
    createdAt: number;
    email: string;
    accepted: boolean;
    expired: boolean;
    permittedToEdit: boolean;
    permittedToRemove: boolean;
    userIsSelf: boolean;
    invitePath?: string | null;
    user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
    permissions?: Array<{
      __typename?: "OrganizationPermission";
      id: string;
      restricted: boolean;
      view: boolean;
      modify: boolean;
      billing: boolean;
      api: boolean;
      manage: boolean;
      createWorkbooks: boolean;
      database?: { __typename?: "Database"; displayName: string } | null;
      server?: { __typename?: "Server"; name: string } | null;
      role: { __typename?: "OrganizationRole"; id: string; name: string };
    } | null> | null;
  };
};

export const MemberDetailsDocument = gql`
  query MemberDetails($membershipId: ID!) {
    getOrganizationMembershipDetails(membershipId: $membershipId) {
      id
      createdAt
      email
      accepted
      expired
      permittedToEdit
      permittedToRemove
      userIsSelf
      invitePath
      user {
        id
        fullname
      }
      permissions {
        id
        database {
          displayName
        }
        server {
          name
        }
        restricted
        view
        modify
        billing
        api
        manage
        createWorkbooks
        role {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useMemberDetailsQuery__
 *
 * To run a query within a React component, call `useMemberDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberDetailsQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useMemberDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MemberDetailsQuery,
    MemberDetailsQueryVariables
  > &
    (
      | { variables: MemberDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MemberDetailsQuery, MemberDetailsQueryVariables>(
    MemberDetailsDocument,
    options,
  );
}
export function useMemberDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MemberDetailsQuery,
    MemberDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MemberDetailsQuery, MemberDetailsQueryVariables>(
    MemberDetailsDocument,
    options,
  );
}
// @ts-ignore
export function useMemberDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MemberDetailsQuery,
    MemberDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MemberDetailsQuery,
  MemberDetailsQueryVariables
>;
export function useMemberDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MemberDetailsQuery,
        MemberDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MemberDetailsQuery | undefined,
  MemberDetailsQueryVariables
>;
export function useMemberDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MemberDetailsQuery,
        MemberDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MemberDetailsQuery,
    MemberDetailsQueryVariables
  >(MemberDetailsDocument, options);
}
export type MemberDetailsQueryHookResult = ReturnType<
  typeof useMemberDetailsQuery
>;
export type MemberDetailsLazyQueryHookResult = ReturnType<
  typeof useMemberDetailsLazyQuery
>;
export type MemberDetailsSuspenseQueryHookResult = ReturnType<
  typeof useMemberDetailsSuspenseQuery
>;
export type MemberDetailsQueryResult = Apollo.QueryResult<
  MemberDetailsQuery,
  MemberDetailsQueryVariables
>;
